import actionTypes from '../actions/action-types';

const initialState = {
  isLoading: false,
  ownerValidationMethod: {},
  ownerData: {},
  retailer: {},
  created: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_OWNER_VALIDATION_METHOD_REQUEST:
    case actionTypes.FETCH_OWNER_VALIDATION_METHOD_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.FETCH_OWNER_VALIDATION_METHOD_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        ownerValidationMethod: action.ownerValidationMethod,
      };
    case actionTypes.VALIDATE_OWNER_DATA_SUCCESS:
      return {
        ...state,
        ownerData: { ...action.ownerData },
      };
    case actionTypes.FETCH_RETAILER_DETAILS_SUCCESS:
      return {
        ...state,
        retailer: action.retailer,
      };
    case actionTypes.FETCH_RETAILER_DETAILS_FAILURE:
    case actionTypes.FETCH_RETAILER_DETAILS_REQUEST:
      return {
        ...state,
        error: action.error,
      };
    case actionTypes.CLEAR_RETAILER_DETAILS:
      return {
        ...state,
        retailer: {},
        ownerData: {},
      };
    case actionTypes.CREATE_ACCOUNT_REQUEST:
    case actionTypes.CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        created: false,
      };
    case actionTypes.CREATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        created: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/registration/reducers/registration.reducer.js